import {XauditModel} from '../xaudit.model';

export class CfgTaskTypeAutodestinationModel extends XauditModel {
  TTDestinationItemID: string;
  TaskCfgID: string;
  isGroup: boolean;
  ObjectID: string;
}
